import React, { useRef } from "react";
import { FiSearch } from "react-icons/fi";

export default function Header({
  setSearch,
  handleModal,
  setIsAdd,
  searchTypes,
  setTypeSearch,
  title,
  setSearchAction,
}) {
  const searchRef = useRef(null);
  const typehRef = useRef(null);

  const handleClearButton = () => {
    if (searchRef.current && typehRef.current) {
      searchRef.current.value = "";
      typehRef.current.value = "";
    }
    setSearch("");
    setTypeSearch("");
    setSearchAction(true);
  };

  return (
    <div className='p-4 bg-white w-full mb-1 min-h-[195px] flex flex-wrap rounded-lg  items-center md:justify-between justify-center border-b border-gray-200 lg:mt-1.5 dark:bg-gray-800 dark:border-gray-700'>
      <div className='flex flex-col p-2 mb-3 sm:divide-x sm:divide-gray-100 sm:mb-0 dark:divide-gray-700 self-start'>
        <h1 className='mb-4 ps-4 text-xl font-semibold text-gray-900 sm:text-2xl dark:text-white'>
          {title}
        </h1>
        <div className='flex md:flex-row flex-col md:gap-0 gap-2'>
          <div className='relative mx-4 lg:w-64 xl:w-96'>
            <input
              ref={searchRef}
              onBlur={(event) => {
                setSearch(event.target.value);
              }}
              type='text'
              className='bg-gray-50 border-2 border-primary text-gray-900 sm:text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:placeholder-gray-400 '
              placeholder='Search'
            />
          </div>
          <select
            ref={typehRef}
            onBlur={(e) => setTypeSearch(e.target.value)}
            className='border-2 border-primary bg-gray-50 p-2.5 sm:text-sm rounded-lg focus:ring-primary focus:border-primary '
          >
            <option value=''>Select Search Type </option>
            {searchTypes.map((item, index) => {
              return (
                <option key={index} value={item}>
                  {item.replace(/_/g, " ").replace(/([A-Z])/g, " $1")}
                </option>
              );
            })}
          </select>
          <button
            onClick={() => handleClearButton()}
            className='inline-flex mx-2 justify-center py-2 pe-2 items-center  text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white'
          >
            <svg
              className='w-10 h-6'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                className='stroke-primary'
                fill='#ffffff'
                strokeWidth='2'
                d='M10,4 C10,2.8954305 10.8954305,2 12,2 C13.1045695,2 14,2.8954305 14,4 L14,10 L20,10 L20,14 L4,14 L4,10 L10,10 L10,4 Z M4,14 L20,14 L20,22 L12,22 L4,22 L4,14 Z M16,22 L16,16.3646005 M8,22 L8,16.3646005 M12,22 L12,16.3646005'
              />
            </svg>
            clear
          </button>
        </div>
      </div>

      <div className='flex md:items-end md:gap-0 items-center gap-2 md:ml-auto space-x-2 sm:space-x-3 md:self-end md:flex-row flex-col'>
        {setIsAdd && (
          <button
            onClick={() => handleModal(setIsAdd, true)}
            type='button'
            data-modal-toggle='add-user-modal'
            className='inline-flex items-center justify-center  px-3 py-2 text-sm font-medium text-center rounded-lg text-primary hover:bg-[#3c2154] hover:text-white    sm:w-auto border-2 border-primary'
          >
            <svg
              className='w-6 h-6 mr-2 -ml-1'
              fill='currentColor'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fillRule='evenodd'
                d='M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z'
                clipRule='evenodd'
              />
            </svg>
            Add User
          </button>
        )}

        <button
          onClick={() => setSearchAction(true)}
          type='button'
          data-modal-toggle='add-user-modal'
          className='inline-flex items-center justify-center max-w-[1000px] px-3 py-2 text-sm font-medium text-center rounded-lg bg-primary hover:bg-[#3c2154] text-white    border-2 border-primary'
        >
          <FiSearch className='w-6 h-6 mr-2 -ml-1' />
          Search
        </button>
      </div>
    </div>
  );
}
